import type React from 'react'
import type { CoverageModel } from './coverage-model.ts'

/** The entry point a part sits under, or the part itself when it is one; none for controls, assets or the repository. */
export const entryPointKeyOf = (model: CoverageModel, key: string | undefined): string | undefined =>
  key === undefined
    ? undefined
    : (model.operations.get(key)?.entryPointKey ??
      model.groups.get(key)?.entryPointKey ??
      model.entryPoints.find(ep => ep.key === key)?.key)

/**
 * Makes a drawn part selectable by click, Enter or Space. A surface can have hundreds of operations, so
 * those pass `isTabbable` only once their entry point (or something under it) is selected: Tab reaches the
 * entry points first, then the parts of the one picked.
 */
export const selectableProps = (key: string, label: string, onSelect: (key: string) => unknown, isTabbable = true) => ({
  role: 'button',
  tabIndex: isTabbable ? 0 : -1,
  'aria-label': label,
  'data-key': key,
  onClick: () => onSelect(key),
  onKeyDown: (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onSelect(key)
    }
  },
})
